export default {
  commonSearch: null,
  status: '',
};

export const config = {
  defaultSearchPropName: 'pageId',
  exceptionFilters: ['status'],
};
